import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: 0,
    label: "menu.profile",
    icon: "mdi mdi-account-circle",
    link: "/users/profile",
    role: "profile"
  },
  {
    id: 1,
    label: "menu.book-ride",
    link: "/users/create-booking",
    icon: "mdi mdi-car",
    role: "create-booking"
  },
  {
    id: 2,
    label: "menu.running",
    icon: "ri ri-riding-line",
    link: "/users/history/running",
    role: "running"
  },
  {
    id: 3,
    label: "menu.completed",
    icon: "bx bx-calendar-check",
    link: "/users/history/completed",
    role: "completed"
  },
  {
    id: 4,
    label: "menu.scheduled",
    icon: "bx bx-calendar",
    link: "/users/history/scheduled",
    role: "scheduled"
  },
  {
    id: 5,
    label: "menu.cancelled",
    icon: "bx bx-calendar-x",
    link: "/users/history/cancelled",
    role: "cancelled"
  },
  {
    id: 11,
    label: "menu.recurring-bookings",
    icon: "ri-repeat-line",
    link: "/users/recurring",
    role: "recurring"
  },
  {
    id: 6,
    label: "menu.exception",
    icon: "ri-file-list-line",
    link: "/users/exception",
    role: "exception"
  }
];
